import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import onClickOutside from 'react-onclickoutside';
import CommonTabItem from 'components/common/tabs/CommonTabItem';

import './DashboardNavBarDropdown.css';

class DashboardNavBarDropdown extends Component {
  static propTypes = {
    tabs: PropTypes.array.isRequired,
    activePage: PropTypes.string.isRequired,
  };

  state = {
    dropdownOpen: false,
  };

  handleClickOutside = () => {
    this.setState({ dropdownOpen: false });
  }

  handleDropdownOpen = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  render() {
    const { dropdownOpen } = this.state;
    const { tabs, activePage } = this.props;

    return (
      <Translation>
        {(t) => (
          <div
            className={`nav-item more dashboard-nav-bar-dropdown__component${dropdownOpen ? ' open' : ''}`}
            onClick={this.handleDropdownOpen}
          >
            <span>{t("more")}</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 7.2 12"
            >
              <path
                d="M1.4 0c.2 0 .3 0 .5.1l.3.3 4.6 4.8c.3.2.4.5.4.8s-.1.6-.3.8l-4.8 4.8c-.1.1-.2.2-.4.3-.2.1-.3.1-.5.1s-.3 0-.5-.1c-.1-.1-.3-.1-.4-.3-.1-.1-.2-.2-.3-.4v-.4c0-.2 0-.3.1-.5.1-.1.1-.3.3-.4l4-3.9L.5 2c-.2-.2-.4-.5-.4-.8C.1.9.2.6.4.4.5.3.6.2.8.1c.2-.1.4-.1.6-.1z"
                />
            </svg>

            {this.state.dropdownOpen &&
              <div className="dashboard-nav-bar-dropdown-content">
                {tabs.map(tabItem => (
                  <CommonTabItem
                    key={`dashboard_nav_bar_mobile_item_${tabItem.id}`}
                    active={activePage === tabItem.pageName}
                    className={
                      `nav-item
                      ${tabItem.labels ? ` label ${tabItem.labels}` : ''}
                      ${tabItem.isMain ? ' main-tab' : ''}
                      ${tabItem.additionalClass ? tabItem.additionalClass : ''}`
                    }
                    tabName={tabItem.tabName}
                    url={tabItem.url}
                  />
                ))}
              </div>
            }
          </div>
        )}
      </Translation>
    );
  }
}

export default onClickOutside(DashboardNavBarDropdown);
